import { projectManagementApi } from '@/includes/projectManagementApi';

const pmForecastService = {
  async getProjectForecast(projectId) {
    const response = await projectManagementApi.get(`/projects/${projectId}/forecast`);
    return response.data;
  },
};

export default pmForecastService;
